<template>
  <div class="home-list">
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      finished-text="已展示全部"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <slot :list="dataList"></slot>
      <template slot="finished">
        <div
          v-if="dataList && dataList.length"
          class="van-list__finished-text-box"
        >
          已展示全部
        </div>
        <van-empty
          v-else-if="isFrist"
          class="van-empty-wrp"
          :description="emptyDescription"
          :image="require('images/platform/homepage/icon-null.png')"
        ></van-empty>
      </template>
    </van-list>
  </div>
</template>

<script>
import { Empty, List } from 'vant'
export default {
  props: {
    getListApi: Function,
    params: {
      type: Object,
      default() {
        return {}
      }
    },
    pageInfo: {
      type: Object,
      default() {
        return {
          page: 2,
          size: 20
        }
      }
    },
    paramsKey: {
      type: Object,
      default() {
        return {
          pageNo: 'page',
          pageSize: 'size',
          listPath: '0.list'
        }
      }
    }
  },
  components: {
    [List.name]: List,
    [Empty.name]: Empty
  },
  data() {
    return {
      dataList: [],
      listInfo: {},
      error: false,
      loading: false,
      finished: false,
      emptyDescription: '暂无内容'
    }
  },
  computed: {
    currentTab() {
      return this.$store.state.homepage.currentTab
    },
    // 是否首次请求
    isFrist() {
      return +this.listInfo[this.paramsKey.pageNo] === 1
    }
  },
  created() {},
  mounted() {
    this.$set(this.listInfo, this.paramsKey.pageNo, this.pageInfo.page || 1)
    this.$set(this.listInfo, this.paramsKey.pageSize, this.pageInfo.size || 20)
    // 优化页面滚动
    document.documentElement.classList.add('html-style')
  },
  methods: {
    onLoad() {
      console.info(
        'onLoad start!!! page is ',
        this.listInfo[this.paramsKey.pageNo]
      )
      // 分页加载埋点，首页不埋
      if (this.listInfo[this.paramsKey.pageNo] > 1) {
        this.$trackEvent('newprofilepages_list_paging', {
          tab_location: this.currentTab.title
        })
      }

      return this.getListApi({ ...this.params, ...this.listInfo })
        .then(({ code, data, message }) => {
          if (+code === 0) {
            // 获取列表
            let list = this.getData(this.paramsKey.listPath, data)

            // 合并列表数据
            this.dataList = this.isFrist ? list : [...this.dataList, ...list]

            this.$emit('getList', {
              isFrist: this.isFrist,
              data: list
            })

            this.listInfo[this.paramsKey.pageNo]++

            // 数据全部加载完成
            if (list.length < this.listInfo[this.paramsKey.pageSize]) {
              this.finished = true
            }
          } else {
            this.error = true
            this.$toast(message)
          }
        })
        .catch(err => {
          console.log('列表加载失败：', err)
          // 若列表数据加载失败，将 error 设置成 true 即可显示错误提示，用户点击错误提示后会重新触发 load 事件。
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 格式化数据
    getData(keys, data) {
      if (!data) return
      let keyList = keys.split('.'),
        result = data
      keyList.map(item => {
        result = result[item]
      })
      return result
    }
  },
  beforeDestroy() {
    document.documentElement.classList.remove('html-style')
  }
}
</script>

<style lang="scss" scoped>
.home-list {
  .van-empty-wrp {
    margin-top: 60px;
  }
}
</style>
<style lang="scss">
html.html-style {
  height: 100%;
  #app {
    overflow: visible !important; // 确保van-list生效
  }
}
.home-list {
  .van-empty-wrp {
    .van-empty__image {
      width: 330px;
      height: 214px;
    }
  }
  .van-list__finished-text {
    position: relative;
    font-size: 24px;
    color: #bcc2cf;
    &::before {
      position: absolute;
      top: 50%;
      left: 61.2%;
      transform: translateY(-50%);
      content: '';
      width: 60px;
      height: 1px;
      background-color: #bcc2cf;
    }
    &::after {
      position: absolute;
      top: 50%;
      right: 61.2%;
      transform: translateY(-50%);
      content: '';
      width: 60px;
      height: 1px;
      background-color: #bcc2cf;
    }
  }
}
</style>
